import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

// Convenience wrappers around the REST CRUD for emergency-response
// providers and templates. The shape mirrors the rest of the codebase
// (device.service.js, etc.) — each call returns res.data when the
// HTTP response is 200 + code "0000", and {} otherwise.

const unwrap = (res) =>
  res && res.status === 200 && res.data && res.data.code === "0000" ? res.data : {};

const buildHeaders = () => ({ headers: authHeader() });

export const emergencyResponseProviders = {
  list({ onlyActive = false } = {}) {
    const url = onlyActive
      ? `${apiEndpoint.emergencyResponseProviders}?only_active=1`
      : apiEndpoint.emergencyResponseProviders;
    return axios.get(url, buildHeaders()).then(unwrap);
  },
  create(data) {
    return axios.post(apiEndpoint.emergencyResponseProviders, data, buildHeaders()).then(unwrap);
  },
  update(id, data) {
    return axios
      .put(`${apiEndpoint.emergencyResponseProviders}/${id}`, data, buildHeaders())
      .then(unwrap);
  },
  remove(id) {
    return axios
      .delete(`${apiEndpoint.emergencyResponseProviders}/${id}`, buildHeaders())
      .then(unwrap);
  },
};

export const emergencyResponseTemplates = {
  list() {
    return axios.get(apiEndpoint.emergencyResponseTemplates, buildHeaders()).then(unwrap);
  },
  create(data) {
    return axios.post(apiEndpoint.emergencyResponseTemplates, data, buildHeaders()).then(unwrap);
  },
  update(id, data) {
    return axios
      .put(`${apiEndpoint.emergencyResponseTemplates}/${id}`, data, buildHeaders())
      .then(unwrap);
  },
  remove(id) {
    return axios
      .delete(`${apiEndpoint.emergencyResponseTemplates}/${id}`, buildHeaders())
      .then(unwrap);
  },
};
